import {
  Grid,
  Card,
  SvgIcon,
  Backdrop,
  Tooltip,
} from "@mui/material";
import styles from "./Sensors.module.scss";
import DeviceThermostatRoundedIcon from '@mui/icons-material/DeviceThermostatRounded';
import Co2RoundedIcon from '@mui/icons-material/Co2Rounded';
import VibrationRoundedIcon from '@mui/icons-material/VibrationRounded';
import DoNotDisturbRoundedIcon from '@mui/icons-material/DoNotDisturbRounded';
import { TrackerRelationshipsService } from "../../../../services/trackerRelationships";
import { useState, useEffect } from "react";

export const SensorsDetails = ({
  openOccurrenceModal,
  openSensorsChartModal,
  setSensorSelectedToChart,
  setSensorDataToChart,
  vehicleDetails,
  isNonMonitored,
  vehicleDetailsTimer,
}) => {
  const trackerRelationshipsService = new TrackerRelationshipsService();
  const [loadingSensorData, setLoadingSensorData] = useState(false);
  const [vehicleDetailsSensor, setVehicleDetailsSensor] = useState(vehicleDetails);

  const handleSensorTempDataResponse = (sensorData) => {
    let labels = [];
    let sensor1Data = [];
    let sensor2Data = [];
    let sensor3Data = [];
    let sensor4Data = [];
    let sensor1Values = [];
    let sensor2Values = [];
    let sensor3Values = [];
    let sensor4Values = [];
    let sensorMinThresholdValues = [];
    let sensorMaxThresholdValues = [];
    let sensorMinThreshold = sensorData[0].sensorMinThreshold;
    let sensorMaxThreshold = sensorData[0].sensorMaxThreshold;

    sensor1Data = sensorData.filter(
      (i) => i.sensorName === "Internal Temperature 1"
    );
    sensor2Data = sensorData.filter(
      (i) => i.sensorName === "Internal Temperature 2"
    );
    sensor3Data = sensorData.filter(
      (i) => i.sensorName === "External Temperature"
    );
    sensor4Data = sensorData.filter(
      (i) => i.sensorName === "Average Temperature"
    );

    for (let i = 0; i < sensor1Data.length; i++) {
      sensor1Values.push(
        parseFloat(sensor1Data[i].sensorValue.replace(",", ".")).toFixed(2)
      );
      sensorMinThresholdValues.push(
        parseFloat(sensor1Data[i].sensorMinThreshold.replace(",", ".")).toFixed(
          2
        )
      );
      sensorMaxThresholdValues.push(
        parseFloat(sensor1Data[i].sensorMaxThreshold.replace(",", ".")).toFixed(
          2
        )
      );
      labels.push(sensor1Data[i].dtEvent);
    }

    for (let i = 0; i < sensor2Data.length; i++) {
      sensor2Values.push(
        parseFloat(sensor2Data[i].sensorValue.replace(",", ".")).toFixed(2)
      );
    }

    for (let i = 0; i < sensor3Data.length; i++) {
      sensor3Values.push(
        parseFloat(sensor3Data[i].sensorValue.replace(",", ".")).toFixed(2)
      );
    }

    for (let i = 0; i < sensor4Data.length; i++) {
      sensor4Values.push(
        parseFloat(sensor4Data[i].sensorValue.replace(",", ".")).toFixed(2)
      );
    }

    const dataToChart = {
      labels: labels,
      sensor1Values: sensor1Values,
      sensor2Values: sensor2Values,
      sensor3Values: sensor3Values,
      sensor4Values: sensor4Values,
      sensorMinThresholdValues: sensorMinThresholdValues,
      sensorMaxThresholdValues: sensorMaxThresholdValues,
      sensorMinThreshold: sensorMinThreshold,
      sensorMaxThreshold: sensorMaxThreshold,
    };
    setSensorDataToChart(dataToChart);
  };

  const handleSensorsDataResponse = (sensorData, sensor) => {
    let labels = [];
    let sensor1Data = [];
    let sensor2Data = [];
    let sensor3Data = [];
    let sensor1Values = [];
    let sensor2Values = [];
    let sensor3Values = [];
    let sensorMinThresholdValues = [];
    let sensorMaxThresholdValues = [];
    let sensorMinThreshold = sensorData[0].sensorMinThreshold;
    let sensorMaxThreshold = sensorData[0].sensorMaxThreshold;

    if (sensor === "humidity") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "Humidity 1");
      sensor2Data = sensorData.filter((i) => i.sensorName === "Humidity 2");
      sensor3Data = sensorData.filter(
        (i) => i.sensorName === "Average Humidity"
      );
    } else if (sensor === "co2") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "CO2");
    } else {
      sensor1Data = sensorData.filter((i) => i.sensorName === "Vibration");
    }

    if (sensor === "humidity") {
      for (let i = 0; i < sensor1Data.length; i++) {
        sensor1Values.push(
          parseFloat(sensor1Data[i].sensorValue.replace(",", ".")).toFixed(2)
        );
        sensorMinThresholdValues.push(
          parseFloat(
            sensor1Data[i].sensorMinThreshold.replace(",", ".")
          ).toFixed(2)
        );
        sensorMaxThresholdValues.push(
          parseFloat(
            sensor1Data[i].sensorMaxThreshold.replace(",", ".")
          ).toFixed(2)
        );
        labels.push(sensor1Data[i].dtEvent);
      }

      for (let i = 0; i < sensor2Data.length; i++) {
        sensor2Values.push(
          parseFloat(sensor2Data[i].sensorValue.replace(",", ".")).toFixed(2)
        );
      }

      for (let i = 0; i < sensor3Data.length; i++) {
        sensor3Values.push(
          parseFloat(sensor3Data[i].sensorValue.replace(",", ".")).toFixed(2)
        );
      }
    } else if (sensor === "co2" || sensor === "mechnical-vibrations") {
      for (let i = 0; i < sensor1Data.length; i++) {
        sensor1Values.push(
          parseFloat(sensor1Data[i].sensorValue.replace(",", ".")).toFixed(2)
        );
        sensorMinThresholdValues.push(
          parseFloat(
            sensor1Data[i].sensorMinThreshold.replace(",", ".")
          ).toFixed(2)
        );
        sensorMaxThresholdValues.push(
          parseFloat(
            sensor1Data[i].sensorMaxThreshold.replace(",", ".")
          ).toFixed(2)
        );
        labels.push(sensor1Data[i].dtEvent);
      }
    }

    const dataToChart = {
      labels: labels,
      sensor1Values: sensor1Values,
      sensor2Values: sensor2Values,
      sensor3Values: sensor3Values,
      sensorMinThresholdValues: sensorMinThresholdValues,
      sensorMaxThresholdValues: sensorMaxThresholdValues,
      sensorMinThreshold: sensorMinThreshold,
      sensorMaxThreshold: sensorMaxThreshold,
    };
    setSensorDataToChart(dataToChart);
    setSensorSelectedToChart(sensor);
  };

  const getDataToChart = (chartSelected) => {
    setLoadingSensorData(true);

    let filters = 0;
    if (chartSelected === "temperature") {
      filters = 1;
    } else if (chartSelected === "humidity") {
      filters = 2;
    } else if (chartSelected === "co2") {
      filters = 3;
    } else {
      filters = 4;
    }

    trackerRelationshipsService
      .getTemperatureDetails(vehicleDetails.trackerRelationShipId, filters)
      .then((res) => {
        if (chartSelected === "temperature") {
          handleSensorTempDataResponse(res.data);
        } else if (chartSelected === "humidity") {
          handleSensorsDataResponse(res.data, "humidity");
        } else if (chartSelected === "co2") {
          handleSensorsDataResponse(res.data, "co2");
        } else {
          handleSensorsDataResponse(res.data, "mechnical-vibrations");
        }

        setLoadingSensorData(false);
      })
      .catch((err) => {
        setLoadingSensorData(false);
      });
  };

  useEffect(() => {
    setVehicleDetailsSensor(vehicleDetails);
  }, [vehicleDetails]);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: 9999999 }}
        open={loadingSensorData}
        onClick={() => setLoadingSensorData(false)}
      >
      </Backdrop>

      <Grid container className={styles.cardSensors} spacing={0.5}>
        <Grid item xl={2} sm={1} md={2} lg={2} xs={4} p={1}>
          {isNonMonitored ? (
            <Card className={`${styles.cardSensor} ${styles.cardNonMonitored}`}>
              <div className={styles.cardHeader}>
                <DeviceThermostatRoundedIcon className={styles.tempIcon} />
              </div>

              <div className={styles.cardContent}>
                {vehicleDetailsSensor.temperatureInt1 + " °C"} <br />
                {vehicleDetailsSensor.temperatureInt2 + " °C"} <br />
                {vehicleDetailsSensor.temperatureExt + " °C"}
              </div>
            </Card>
          ) : (
            <Tooltip title="Gráfico de Temperatura Interna / Externa">
              <Card
                className={styles.cardSensor}
                onClick={() => {
                  getDataToChart("temperature");
                  vehicleDetailsTimer = setInterval(() => {
                    getDataToChart("temperature");
                  }, 60000);
                  sessionStorage.setItem(
                    "id_interval_sensorChart",
                    vehicleDetailsTimer
                  );
                  setSensorSelectedToChart("temperature");
                  openSensorsChartModal();
                }}
              >
                <div className={styles.cardHeader}>
                  <DeviceThermostatRoundedIcon className={styles.tempIcon} />
                </div>

                <div className={styles.cardContent}>
                  {vehicleDetailsSensor.temperatureInt1 + " °C"} <br />
                  {vehicleDetailsSensor.temperatureInt2 + " °C"} <br />
                  {vehicleDetailsSensor.temperatureExt + " °C"}
                </div>
              </Card>
            </Tooltip>
          )}
        </Grid>
        <Grid item xl={2} sm={1} md={2} lg={2} xs={4} p={1}>
          {isNonMonitored ? (
            <Card className={`${styles.cardSensor} ${styles.cardNonMonitored}`}>
              <div className={styles.cardHeader}>
                <SvgIcon className={styles.sensorIcon}>
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M12,3.25C12,3.25 6,10 6,14C6,17.32 8.69,20 12,20A6,6 0 0,0 18,14C18,10 12,3.25 12,3.25M14.47,9.97L15.53,11.03L9.53,17.03L8.47,15.97M9.75,10A1.25,1.25 0 0,1 11,11.25A1.25,1.25 0 0,1 9.75,12.5A1.25,1.25 0 0,1 8.5,11.25A1.25,1.25 0 0,1 9.75,10M14.25,14.5A1.25,1.25 0 0,1 15.5,15.75A1.25,1.25 0 0,1 14.25,17A1.25,1.25 0 0,1 13,15.75A1.25,1.25 0 0,1 14.25,14.5Z"
                  />
                </SvgIcon>
              </div>

              <div className={styles.cardContent}>
                {vehicleDetailsSensor.humidity1 + " %"} <br />
                {vehicleDetailsSensor.humidity2 + " %"}
              </div>
            </Card>
          ) : (
            <Tooltip title="Gráfico de Umidade">
              <Card
                className={styles.cardSensor}
                onClick={() => {
                  getDataToChart("humidity");
                  vehicleDetailsTimer = setInterval(() => {
                    getDataToChart("humidity");
                  }, 60000);
                  sessionStorage.setItem(
                    "id_interval_sensorChart",
                    vehicleDetailsTimer
                  );
                  setSensorSelectedToChart("humidity");
                  openSensorsChartModal();
                }}
              >
                <div className={styles.cardHeader}>
                  <SvgIcon className={styles.sensorIcon}>
                    <path
                      xmlns="http://www.w3.org/2000/svg"
                      d="M12,3.25C12,3.25 6,10 6,14C6,17.32 8.69,20 12,20A6,6 0 0,0 18,14C18,10 12,3.25 12,3.25M14.47,9.97L15.53,11.03L9.53,17.03L8.47,15.97M9.75,10A1.25,1.25 0 0,1 11,11.25A1.25,1.25 0 0,1 9.75,12.5A1.25,1.25 0 0,1 8.5,11.25A1.25,1.25 0 0,1 9.75,10M14.25,14.5A1.25,1.25 0 0,1 15.5,15.75A1.25,1.25 0 0,1 14.25,17A1.25,1.25 0 0,1 13,15.75A1.25,1.25 0 0,1 14.25,14.5Z"
                    />
                  </SvgIcon>
                </div>

                <div className={styles.cardContent}>
                  {vehicleDetailsSensor.humidity1 + " %"} <br />
                  {vehicleDetailsSensor.humidity2 + " %"}
                </div>
              </Card>
            </Tooltip>
          )}
        </Grid>

        <Grid item xl={2} sm={1} md={2} lg={2} xs={4} p={1}>
          {isNonMonitored ? (
            <Card className={`${styles.cardSensor} ${styles.cardNonMonitored}`}>
              <div className={styles.cardHeader}>
                <Co2RoundedIcon className={styles.co2Icon} />
              </div>

              <div className={`${styles.cardContent} ${styles.cardCo2}`}>
                {vehicleDetailsSensor.firstCo2 + " PPM"} <br />
              </div>
            </Card>
          ) : (
            <Tooltip title="Gráfico de CO2">
              <Card
                className={styles.cardSensor}
                onClick={() => {
                  getDataToChart("co2");
                  vehicleDetailsTimer = setInterval(() => {
                    getDataToChart("co2");
                  }, 60000);
                  sessionStorage.setItem(
                    "id_interval_sensorChart",
                    vehicleDetailsTimer
                  );
                  setSensorSelectedToChart("co2");
                  openSensorsChartModal();
                }}
              >
                <div className={styles.cardHeader}>
                  <Co2RoundedIcon className={styles.co2Icon} />
                </div>

                <div className={`${styles.cardContent} ${styles.cardCo2}`}>
                  {vehicleDetailsSensor.firstCo2 + " PPM"} <br />
                </div>
              </Card>
            </Tooltip>
          )}
        </Grid>
        <Grid item xl={2} sm={1} md={2} lg={2} xs={4} p={1}>
          {isNonMonitored ? (
            <Card className={`${styles.cardSensor} ${styles.cardNonMonitored}`}>
              <div className={styles.cardHeader}>
                <VibrationRoundedIcon className={styles.vibIcon} />
              </div>

              <div className={styles.cardContent}>
                {vehicleDetailsSensor.vibration1 + " G"} <br />
              </div>
            </Card>
          ) : (
            <Tooltip title="Gráfico de Vibração Mecânica">
              <Card
                className={styles.cardSensor}
                onClick={() => {
                  getDataToChart("mechnical-vibrations");
                  vehicleDetailsTimer = setInterval(() => {
                    getDataToChart("mechnical-vibrations");
                  }, 60000);
                  sessionStorage.setItem(
                    "id_interval_sensorChart",
                    vehicleDetailsTimer
                  );
                  setSensorSelectedToChart("mechnical-vibrations");
                  openSensorsChartModal();
                }}
              >
                <div className={styles.cardHeader}>
                  <VibrationRoundedIcon className={styles.vibIcon} />
                </div>

                <div className={styles.cardContent}>
                  {vehicleDetailsSensor.vibration1 + " g"} <br />
                </div>
              </Card>
            </Tooltip>
          )}
        </Grid>
        <Grid item xl={2} sm={1} md={2} lg={2} xs={4} p={1}>
          {isNonMonitored ? (
            <Card className={`${styles.cardSensor} ${styles.cardNonMonitored}`}>
              <div className={styles.cardHeader}>
                <DoNotDisturbRoundedIcon className={styles.occurreceIcon} />
              </div>
              <div className={styles.cardContent}>{"Ocorrências"}</div>
            </Card>
          ) : (
            <Tooltip title="Ocorrências">
              <Card
                className={styles.cardSensor}
                onClick={() => {
                  openOccurrenceModal();
                }}
              >
                <div className={styles.cardHeader}>
                  <DoNotDisturbRoundedIcon className={styles.occurreceIcon} />
                </div>

                <div className={styles.cardContent}>{"Ocorrências"}</div>
              </Card>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    </>
  );
};
